import React from 'react';
import { Card, CardContent, Badge } from '@roger/ui-components';
import { Calendar, User, Stethoscope } from 'lucide-react';
import { QAVisit } from '@/types/visitData.types';
import { getVisitTypeDisplayName } from '../hooks/useVisitTypeOptions';

interface QAVisitCardProps {
  visit: QAVisit;
  onClick: (visit: QAVisit) => void;
}

const QALegacyVisitCard: React.FC<QAVisitCardProps> = ({ visit, onClick }) => {
  return (
    <Card
      className='transition-all duration-200 cursor-pointer hover:bg-blue-50 hover:border-blue-300 hover:shadow-md hover:-translate-y-0.5 border-gray-200'
      onClick={() => onClick(visit)}
    >
      <CardContent>
        <div className='flex items-center gap-4 flex-wrap'>
          {/* Patient Name & MRN */}
          <div className='flex items-center gap-2 min-w-[250px]'>
            <span className='font-semibold text-gray-900 text-sm'>
              {visit.patient_first_name} {visit.patient_last_name}
            </span>
            {visit.patient_id && (
              <Badge variant='secondary' className='text-xs font-mono'>
                {visit.patient_id}
              </Badge>
            )}
          </div>

          {/* Visit Date */}
          <div className='flex items-center gap-1 min-w-[100px]'>
            <Calendar className='w-4 h-4 text-gray-500' />
            <span className='text-sm text-gray-600'>{visit.visit_date}</span>
          </div>

          {/* Nurse */}
          <div className='flex items-center gap-1 min-w-[140px]'>
            <User className='w-4 h-4 text-gray-500' />
            <span className='text-sm text-gray-600'>
              {visit.nurse_username}
            </span>
          </div>

          {/* Visit Type */}
          <div className='flex items-center gap-1 min-w-[100px]'>
            <Stethoscope className='w-4 h-4 text-gray-500' />
            <span className='text-sm text-gray-600'>
              {getVisitTypeDisplayName(visit.visit_type)}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default QALegacyVisitCard;
